import { Component } from '@angular/core';
import { Platform, ToastController,IonicPage, NavController, NavParams } from 'ionic-angular';
import {FormGroup,FormControl,Validators,FormBuilder } from "@angular/forms";
import { CommonService } from '../../services/common.service';
import { Http} from '@angular/http';
import { AuthService } from './../../providers/auth-service';


/**
 * Generated class for the SettingsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 @IonicPage()
 @Component({
 	selector: 'page-settings',
 	templateUrl: 'settings.html',
 })
 export class SettingsPage {

 	public person :any ={};
 	showTab=0;
 	tabTitle='';
 	public loggedUserDetail : any ={};
 	allCategory=[];
 	userPasswords: any={};
 	companyInfo: any={};
   mySubscription : any = {};
 	isSuperAdmin=false;
 	autocompleteItems=[];
 	autocomplete={query:''};

 	/*******Validation Start************/
 	registerForm = new FormGroup({
 		firstName: new FormControl(), 
 		lastName: new FormControl(), 
 		email: new FormControl(),
 		phoneNumber : new FormControl(),
 		password: new FormControl(),
 		confirmPassword: new FormControl() 
 	});


 	companyInfoForm = new FormGroup({
 		categoryId: new FormControl(),
 		companyAddress: new FormControl(),
 		companyName: new FormControl() 
 	});

 	changePasswordForm = new FormGroup({
 		oldPassword: new FormControl(),
 		password: new FormControl(),
 		confirmPassword: new FormControl()  
 	});


 	

 	constructor(public navCtrl: NavController, public navParams: NavParams,public fb : FormBuilder , public commonService :CommonService , private http:Http, private auth: AuthService, private platform:Platform, private toastCtrl:ToastController) {

     this.platform.ready().then(() => { 
      //back button handle
      //Registration of push in Android and Windows Phone
      var lastTimeBackPress=0;
      var timePeriodToExit=2000;

      this.platform.registerBackButtonAction(() => {
        this.showTab=0;
        if(new Date().getTime() - lastTimeBackPress < timePeriodToExit){
          this.platform.exitApp(); 
                 //Exit from app
               }else{
                 let toast = this.toastCtrl.create({
                   message: 'Press back again to exit App?',
                   duration: 3000,
                   position: 'bottom'
                 });
                 toast.present();     
                 lastTimeBackPress=new Date().getTime();
               }      
            }, 500);
    });
 	}


 	ngOnInit() {
 		this.showTab=0;
 		this.tabTitle='';

 		var loginUserData=this.commonService.getLoggedInUserData();
 		this.loggedUserDetail=this.commonService.getLoggedInUserData();
 		var fullNameArray=this.commonService.getLoggedInUserData().fullName.split(" ");
 		this.loggedUserDetail.firstName=fullNameArray[0];
 		this.loggedUserDetail.lastName=fullNameArray[1];

 		if(this.loggedUserDetail.isSuperAdmin=='1'){
 			this.isSuperAdmin=true;
 		}

 		this.companyInfo.companyName=loginUserData.company.companyName;
 		this.companyInfo.categoryId=loginUserData.company.categoryId;
 		this.companyInfo.companyAddress=loginUserData.company.addressLineOne;

 		var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;


 		this.registerForm = this.fb.group({
 			firstName: [this.loggedUserDetail.firstName, Validators.compose([Validators.required, Validators.pattern('[A-Za-z]{2,32}')])],
 			lastName: [this.loggedUserDetail.lastName, Validators.compose([Validators.required, Validators.pattern('[A-Za-z]{2,32}')])], 			
 			email: [this.loggedUserDetail.email, Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
 			phoneNumber: [this.loggedUserDetail.phoneNumber, Validators.compose([Validators.required, Validators.minLength(5), Validators.minLength(10)])],      

 		});  


 		this.companyInfoForm = this.fb.group({
 			companyName: [this.companyInfo.companyName, Validators.compose([Validators.required, Validators.pattern('[A-Za-z1-9 ]{2,32}')])],
 			categoryId: [this.companyInfo.categoryId, Validators.compose([Validators.required])],
 			companyAddress: [this.companyInfo.companyAddress, Validators.compose([Validators.required])],       

 		});  

 		this.changePasswordForm = this.fb.group({
 			oldPassword: [this.userPasswords.companyName, Validators.compose([Validators.required])],
 			password: [this.userPasswords.password, Validators.compose([Validators.required,  Validators.minLength(6)])],
 			confirmPassword: [this.userPasswords.confirmPassword, Validators.compose([Validators.required])],      

 		}, 
 		{'validator': this.matchingPasswords('password', 'confirmPassword')});  

 		this.getCategories();
    this.getSubscription();  

 	}  

 	public matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
 		return (group: FormGroup) => {
 			let passwordInput = group.controls[passwordKey];
 			let passwordConfirmationInput = group.controls[passwordConfirmationKey];
 			if (passwordInput.value !== passwordConfirmationInput.value) {
 				return passwordConfirmationInput.setErrors({notEquivalent: true})
 			}
 		}
 	}


 	ionViewDidLoad() {
 		console.log('ionViewDidLoad SettingsPage');
 	}

 	goToSetting(pageName){
 		//this.navCtrl.push()
 	}


 	public getCategories(){

 		this.commonService.getCategories().subscribe(success => {
 			if (success) {

 				this.allCategory=success.data;

 			} else {
 				this.commonService.showPopup("Error", "Problem creating account.");
 			}

 		})
 	}

  public getSubscription(){

     this.commonService.getMySubscription().subscribe(data => {
       if (data) {
         console.log("datadata", data)

         this.mySubscription=data;
         this.mySubscription.status = data.status=='authenticated'?'Trial':data.status;
         this.mySubscription.nextPaymentDate = data.charge_at ? new Date(data.charge_at* 1000).toDateString():'N/A';

       } else {
         this.commonService.showPopup("Error", "Problem getting subscription data.");
       }

     })
   }

   public cancelSubscription(){

     if(confirm('Sure, want to cancel susbcription?')){

       this.commonService.cancelMySubscription().subscribe(data => {
         if (data) {
           this.commonService.showPopup("Success", "Your subscription canceled successfully.");

         } else {
           this.commonService.showPopup("Error", "Problem getting subscription data.");
         }

       })
     }
   }

 	public getGooglePlaces(event){


 		let me =this;
 		this.http.get('http://35.165.185.224:3000/api/getPlaces?search='+this.autocomplete.query)
 		.map(response => response.json())
 		.subscribe(data => {


 			me.autocompleteItems=data.predictions;


 		}, error => {
		        console.log(error);// Error getting the data
		        
		    });;


 	}

 	public updateUserInfo(formValues) {

 		this.commonService.showLoading();

 		formValues.userId=(this.commonService.getLoggedInUserData())?this.commonService.getLoggedInUserData().userId:'';

 		this.auth.updateUserInfo(formValues).subscribe(success => {

 			this.commonService.dismisshowoading();
 			if (success && success.status=="success") {

 				var loginUserData=this.commonService.getLoggedInUserData();
 				loginUserData.fullName=formValues.firstName+" "+formValues.lastName;
 				loginUserData.email=formValues.email;
 				loginUserData.phoneNumber=formValues.phoneNumber;
 				this.commonService.setLoggedInUserData(loginUserData);


 				this.commonService.showPopup("Success", "Your changes saved successfully.");


 			} else {

 				this.commonService.showPopup("Fail", "Invalid user.");
 			}
 		});  
          /*,
        error => {
          this.commonService.dismisshowoading();
          console.log("ssssssssssss error",error);
          this.showPopup("Error server", error);
      });*/
  }

  public updatePassword(formValues) {

  	if(formValues.password!=formValues.confirmPassword){
  		this.commonService.showPopup("Fail", "Password did not match with confirm password.");
  		return;
  	}

  	this.commonService.showLoading();

  	formValues.userId=(this.commonService.getLoggedInUserData())?this.commonService.getLoggedInUserData().userId:'';

  	this.auth.updatePassword(formValues).subscribe(success => {

  		console.log(success);
  		this.commonService.dismisshowoading();
  		if (success && success.status=="success") {
           //  this.createSuccess = true;

           this.changePasswordForm.reset()
           this.commonService.showPopup("Success", "Your password changed successfully.");


       } else {

       	this.commonService.showPopup("Fail", "Invalid user or old-password.");
       }
   });  
          /*,
        error => {
          this.commonService.dismisshowoading();
          console.log("ssssssssssss error",error);
          this.showPopup("Error server", error);
      });*/
  }

  public updateCompanyInfo(formValues) {
  	this.commonService.showLoading();
  	formValues.companyId=(this.commonService.getLoggedInUserData())?this.commonService.getLoggedInUserData().companyId:'';

  	this.auth.updateCompanyInfo(formValues).subscribe(success => {

  		this.commonService.dismisshowoading();
  		if (success && success.status=="success") {
           //  this.createSuccess = true;

           var loginUserData=this.commonService.getLoggedInUserData();
           loginUserData.company.companyName=formValues.companyName;
           loginUserData.company.categoryId=formValues.categoryId;
           loginUserData.company.addressLineOne=formValues.companyAddress;
           this.commonService.setLoggedInUserData(loginUserData);

           this.commonService.showPopup("Success", "Your changes saved successfully.");


       } else {

       	this.commonService.showPopup("Fail", "Invalid user or old-password.");
       }
   });  
          /*,
        error => {
          this.commonService.dismisshowoading();
          console.log("ssssssssssss error",error);
          this.showPopup("Error server", error);
      });*/
  }


}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts